module.exports = __webpack_public_path__ + "img/mingbai4_1f1f8b4b8.png";